import { calculateScreen, onScreenUpdate } from "common/screen";
import * as PIXI from "pixi.js";
export function createApplication(parentSelector, transitionImage) {
    const { screen, viewport } = calculateScreen();
    const app = new PIXI.Application({
        width: viewport.width,
        height: viewport.height,
    });
    $(app.view)
        .attr("id", "pixi-canvas")
        .attr("width", viewport.width)
        .attr("height", viewport.height)
        .attr("class", "pointer-allow")
        .css("width", screen.width)
        .css("height", screen.height);
    if (transitionImage) {
        console.log("use transition image to create phaser app.");
        transitionImage.appendSceneBeforeImage(app.view);
    }
    else {
        console.log("create phaser app without transition image");
        $(parentSelector).append(app.view);
    }
    return app;
}
export function createCenterContainer() {
    const { viewport: { width, height }, } = calculateScreen();
    const centerContainer = new PIXI.Container();
    centerContainer.position.x = width / 2;
    centerContainer.position.y = height / 2;
    onScreenUpdate(({ viewport: { width, height } }) => {
        centerContainer.position.x = width / 2;
        centerContainer.position.y = height / 2;
    });
    return centerContainer;
}
//# sourceMappingURL=app.js.map